// WhatsApp Business Cloud API ayarları (Admin Paneli → Entegrasyonlar).
// Erişim anahtarı ve App Secret YALNIZ YAZILIR: sunucu bir daha geri
// göndermez, ekranda "kayıtlı · son 4" görünür. Alan boş kaydedilirse
// kayıtlı değer korunur. Bkz. backend/whatsapp.py, routes/whatsapp_bildirim.py.
import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MessageCircle, RefreshCw, ShieldCheck, AlertTriangle, Copy } from 'lucide-react';
import { toast } from 'sonner';

const BOS = { phone_number_id: '', waba_id: '', api_version: '', dry_run: true, test_whitelist: '',
  sablon_linkli: '', sablon_bilgi: '', access_token: '', app_secret: '' };

const Ortamdan = ({ k }) => (k === 'ortam'
  ? <span className="ml-1 text-[10px] font-semibold uppercase text-[#7a6a2e]">.env'den — burada değişmez</span>
  : null);

const SABLON_DURUM = {
  APPROVED: ['Onaylı', 'text-[#3d6e4e] bg-[#3d6e4e]/10'],
  PENDING: ['Onay bekliyor', 'text-[#7a6a2e] bg-[#7a6a2e]/10'],
  IN_APPEAL: ['İtirazda', 'text-[#7a6a2e] bg-[#7a6a2e]/10'],
  REJECTED: ['Reddedildi', 'text-[#9b3b2f] bg-[#9b3b2f]/10'],
  PAUSED: ['Duraklatıldı', 'text-[#9b3b2f] bg-[#9b3b2f]/10'],
  DISABLED: ['Devre dışı', 'text-[#9b3b2f] bg-[#9b3b2f]/10'],
};

function SablonBolumu() {
  const [v, setV] = useState(null);
  const [mesgul, setMesgul] = useState(null);
  const yukle = () => api.get('/whatsapp/ayarlar/sablonlar').then(r => setV(r.data)).catch(() => {});
  useEffect(() => { yukle(); }, []);

  const gonder = async (s) => {
    if (!window.confirm(`"${s.ad}" şablonu Meta'ya onaya gönderilsin mi?`)) return;
    setMesgul(s.tur);
    try {
      const r = await api.post(`/whatsapp/ayarlar/sablonlar/${s.tur}`);
      toast.success(`${r.data.ad} onaya gönderildi (${r.data.durum || 'beklemede'})`);
      yukle();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Gönderilemedi'); }
    setMesgul(null);
  };

  const eksikler = (v?.sablonlar || []).filter(s => !s.durum);
  const hepsiniGonder = async () => {
    if (!window.confirm(`${eksikler.length} şablon Meta'ya onaya gönderilsin mi?`)) return;
    setMesgul('hepsi');
    let ok = 0;
    for (const s of eksikler) {
      try { await api.post(`/whatsapp/ayarlar/sablonlar/${s.tur}`); ok += 1; }
      catch (e) { toast.error(`${s.ad}: ${e?.response?.data?.detail || 'gönderilemedi'}`); }
    }
    if (ok) toast.success(`${ok} şablon onaya gönderildi`);
    setMesgul(null);
    yukle();
  };

  if (!v) return null;
  return (
    <div className="rounded-md border border-[#d0c4b0] bg-white px-3 py-2.5 space-y-3" data-testid="wa-sablonlar">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-semibold text-[#3F3E39]">Şablonlar (Meta)</p>
        <div className="flex gap-1">
          {eksikler.length > 1 && (
            <Button size="sm" variant="outline" disabled={!!mesgul} onClick={hepsiniGonder}
              className="h-7 text-xs border-[#d0c4b0] text-[#3d6e4e]" data-testid="wa-sablon-hepsi">
              Eksik {eksikler.length} şablonu gönder
            </Button>
          )}
          <Button size="sm" variant="ghost" onClick={yukle} className="h-7 text-xs"><RefreshCw size={12} className="mr-1" />Yenile</Button>
        </div>
      </div>
      <p className="text-[11px] text-[#8a7e70]">
        Her işin kendi (özel) şablonu Meta'da onaylıysa o gider; değilse genel şablon kullanılır.
        Özel şablonlar UTILITY kategorisinde onaylanır, genel şablonu Meta MARKETING sayabilir.
      </p>
      {v.hata && <p className="text-xs text-[#9b3b2f]">{v.hata}</p>}
      {v.sablonlar.map(s => {
        const [etiket, sinif] = s.durum ? (SABLON_DURUM[s.durum] || [s.durum, 'text-[#8a7e70] bg-[#8a7e70]/10'])
          : ["Meta'da yok", 'text-[#9b3b2f] bg-[#9b3b2f]/10'];
        return (
          <div key={s.tur} className="border-t border-[#efe8dc] pt-2 space-y-1" data-testid={`wa-sablon-${s.tur}`}>
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-mono text-xs font-semibold">{s.ad}</span>
              <span className="text-[11px] text-[#8a7e70]">{s.aciklama}</span>
              <span className={`status-badge ${sinif}`}>{etiket}</span>
              {s.kategori && s.kategori !== 'UTILITY' && (
                <span className="status-badge text-[#9b3b2f] bg-[#9b3b2f]/10">Kategori: {s.kategori}</span>)}
              {(!s.durum || s.durum === 'REJECTED') && (
                <Button size="sm" variant="outline" disabled={!!mesgul} onClick={() => gonder(s)}
                  className="h-7 text-xs border-[#d0c4b0] text-[#3d6e4e]" data-testid={`wa-sablon-gonder-${s.tur}`}>
                  {mesgul === s.tur ? 'Gönderiliyor…' : "Meta'ya onaya gönder"}
                </Button>
              )}
            </div>
            {s.gerekce && <p className="text-xs text-[#9b3b2f]">Ret gerekçesi: {s.gerekce}</p>}
            <details className="text-xs text-[#5c554b]">
              <summary className="cursor-pointer text-[#8a7e70]">Metin</summary>
              <p className="whitespace-pre-wrap mt-1 rounded bg-[#faf7f2] p-2">{s.metin}</p>
              {s.buton && <p className="mt-1">Buton: <b>{s.buton}</b> → <span className="font-mono">{s.buton_adresi}</span></p>}
            </details>
          </div>
        );
      })}
      {v.digerleri?.length > 0 && (
        <p className="text-[11px] text-[#8a7e70]">
          Hesaptaki diğer şablonlar: {v.digerleri.map(d => `${d.ad} (${d.kategori}, ${d.durum})`).join(' · ')}
        </p>
      )}
    </div>
  );
}

export default function WhatsAppAyarKarti() {
  const { role } = useAuth();
  const [g, setG] = useState(null);          // sunucu görünümü
  const [f, setF] = useState(BOS);           // form
  const [mesgul, setMesgul] = useState(false);
  const [test, setTest] = useState(null);
  const [testNo, setTestNo] = useState('');
  const [testGonder, setTestGonder] = useState({ mesgul: false, sonuc: null });

  const yukle = (d) => {
    setG(d);
    setF({ ...BOS, phone_number_id: d.phone_number_id, waba_id: d.waba_id, api_version: d.api_version,
      dry_run: d.dry_run, test_whitelist: (d.test_whitelist || []).join(', '),
      sablon_linkli: d.sablon_linkli || '', sablon_bilgi: d.sablon_bilgi || '' });
  };
  useEffect(() => {
    if (role !== 'super_admin') return;
    api.get('/whatsapp/ayarlar').then(r => yukle(r.data)).catch(() => {});
  }, [role]);

  if (role !== 'super_admin') return null;
  if (!g) return null;
  const k = g.kaynak || {};

  const kaydet = async (ek = {}) => {
    setMesgul(true);
    try {
      // .env'den gelen alan gönderilmez: orada kazanan .env, kopyası birikmesin
      const govde = Object.fromEntries(
        ['phone_number_id', 'waba_id', 'api_version', 'dry_run', 'test_whitelist', 'sablon_linkli', 'sablon_bilgi']
          .filter(a => k[a] !== 'ortam').map(a => [a, f[a]]));
      Object.assign(govde, ek);
      if (f.access_token.trim()) govde.access_token = f.access_token.trim();
      if (f.app_secret.trim()) govde.app_secret = f.app_secret.trim();
      const r = await api.patch('/whatsapp/ayarlar', govde);
      yukle(r.data);
      setTest(null);
      toast.success('WhatsApp ayarları kaydedildi');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Kaydedilemedi');
    } finally { setMesgul(false); }
  };

  const sil = async (alan, ad) => {
    if (!window.confirm(`${ad} silinsin mi? Silinirse WhatsApp gönderimi durur.`)) return;
    await kaydet({ sil: [alan] });
  };

  const metinUret = async () => {
    if (g.webhook_verify_token && !window.confirm(
      'Yeni doğrulama metni üretilirse Meta panelindeki "Verify token" da güncellenmeli. Devam edilsin mi?')) return;
    try {
      const r = await api.post('/whatsapp/ayarlar/dogrulama-metni-uret');
      yukle(r.data);
      toast.success('Doğrulama metni üretildi');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Üretilemedi'); }
  };

  const baglantiDene = async () => {
    setTest({ mesgul: true });
    try {
      const r = await api.post('/whatsapp/ayarlar/baglanti-testi');
      setTest(r.data);
    } catch (e) { setTest({ ok: false, hata: e?.response?.data?.detail || 'Test yapılamadı' }); }
  };

  const testMesaji = async (linkli) => {
    setTestGonder({ mesgul: true, sonuc: null });
    try {
      const r = await api.post('/whatsapp/ayarlar/test-mesaji', { telefon: testNo || g.test_whitelist[0], linkli });
      setTestGonder({ mesgul: false, sonuc: r.data });
    } catch (e) {
      setTestGonder({ mesgul: false, sonuc: { durum: 'hata', hata: e?.response?.data?.detail || 'Gönderilemedi' } });
    }
  };

  const kopyala = (metin) => {
    navigator.clipboard?.writeText(metin).then(() => toast.success('Kopyalandı'), () => {});
  };

  return (
    <Card className="bg-[#faf7f2] border-[#d0c4b0] mb-6" data-testid="whatsapp-ayar-karti">
      <CardHeader className="border-b border-[#d0c4b0]">
        <CardTitle className="text-lg font-bold text-[#1a1916] flex items-center gap-2">
          <MessageCircle size={18} /> WhatsApp Business (Cloud API)
        </CardTitle>
        <p className="text-xs text-[#8a7e70]">
          İnşaat günlük rapor hatırlatmaları buradan gönderilir. Erişim anahtarı ve App Secret
          şifreli saklanır ve bir daha gösterilmez; alanı boş bırakırsanız kayıtlı değer korunur.
          Yalnız Super Admin görür.
        </p>
        {!g.sifreleme_hazir && (
          <p className="text-xs text-[#9b3b2f] bg-[#9b3b2f]/10 border border-[#9b3b2f]/30 rounded-md px-3 py-2 mt-2 flex gap-2">
            <AlertTriangle size={14} className="shrink-0 mt-0.5" />
            Sunucuda şifreleme anahtarı tanımlı değil; gizli alanlar kaydedilemez.
          </p>
        )}
        {g.cozulemeyen?.length > 0 && (
          <p className="text-xs text-[#9b3b2f] bg-[#9b3b2f]/10 border border-[#9b3b2f]/30 rounded-md px-3 py-2 mt-2 flex gap-2">
            <AlertTriangle size={14} className="shrink-0 mt-0.5" />
            Kayıtlı gizli değerler okunamıyor (sunucu anahtarı değişmiş). Lütfen yeniden girin.
          </p>
        )}
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        {/* Deneme modu en üstte: canlı gönderimi açan anahtar bu */}
        <label className={`flex items-start gap-3 rounded-lg border px-3 py-2.5 cursor-pointer
          ${f.dry_run ? 'border-[#7a6a2e]/40 bg-[#7a6a2e]/10' : 'border-[#3d6e4e]/40 bg-[#3d6e4e]/10'}`}>
          <input type="checkbox" className="mt-1" checked={f.dry_run} disabled={k.dry_run === 'ortam'}
            data-testid="wa-dry-run" onChange={(e) => setF(p => ({ ...p, dry_run: e.target.checked }))} />
          <span className="text-sm">
            <b>Deneme modu</b> <Ortamdan k={k.dry_run} />
            <span className="block text-xs text-[#5c554b]">
              {f.dry_run
                ? 'Açık: mesaj GÖNDERİLMEZ, yalnız kayıt düşülür.'
                : 'Kapalı: mesajlar gerçekten gönderilir.'}
            </span>
          </span>
        </label>

        <div className="space-y-1">
          <Label className="text-[#3F3E39]">Test numaraları <Ortamdan k={k.test_whitelist} /></Label>
          <div className="flex gap-2">
            <Input value={f.test_whitelist} disabled={k.test_whitelist === 'ortam'} data-testid="wa-whitelist"
              placeholder="Boş = herkese gönderilir (canlı)"
              onChange={(e) => setF(p => ({ ...p, test_whitelist: e.target.value }))}
              className="bg-white border-[#d0c4b0]" />
            {g.test_whitelist?.length > 0 && k.test_whitelist !== 'ortam' && (
              <Button type="button" variant="outline" disabled={mesgul} data-testid="wa-test-modu-kapat"
                className="border-[#d0c4b0] text-[#9b3b2f] whitespace-nowrap"
                onClick={() => {
                  if (window.confirm('Test modu kapatılsın mı? Bundan sonra mesajlar herkese gerçekten gönderilir.')) {
                    setF(p => ({ ...p, test_whitelist: '' }));
                    kaydet({ test_whitelist: '' });
                  }
                }}>
                Test modunu kapat
              </Button>
            )}
          </div>
          <p className="text-[11px] text-[#8a7e70]">
            {g.test_whitelist?.length > 0
              ? <><b>Test modu açık:</b> mesaj yalnız bu numaralara gider, diğerleri "engellendi" olarak kaydedilir.</>
              : <>Boş: mesajlar herkese gider. Denemek için buraya kendi numaranızı yazıp kaydedin.</>}
          </p>
        </div>

        <div className="grid gap-3 xl:grid-cols-3">
          <div className="space-y-1">
            <Label className="text-[#3F3E39]">Phone Number ID <Ortamdan k={k.phone_number_id} /></Label>
            <Input value={f.phone_number_id} disabled={k.phone_number_id === 'ortam'} inputMode="numeric"
              data-testid="wa-phone-id" onChange={(e) => setF(p => ({ ...p, phone_number_id: e.target.value }))}
              className="bg-white border-[#d0c4b0]" />
          </div>
          <div className="space-y-1">
            <Label className="text-[#3F3E39]">WABA ID <Ortamdan k={k.waba_id} /></Label>
            <Input value={f.waba_id} disabled={k.waba_id === 'ortam'} inputMode="numeric"
              data-testid="wa-waba-id" onChange={(e) => setF(p => ({ ...p, waba_id: e.target.value }))}
              className="bg-white border-[#d0c4b0]" />
          </div>
          <div className="space-y-1">
            <Label className="text-[#3F3E39]">API sürümü <Ortamdan k={k.api_version} /></Label>
            <Input value={f.api_version} disabled={k.api_version === 'ortam'} placeholder="v25.0"
              data-testid="wa-api-version" onChange={(e) => setF(p => ({ ...p, api_version: e.target.value }))}
              className="bg-white border-[#d0c4b0]" />
          </div>
        </div>

        <div className="grid gap-3 xl:grid-cols-2">
          <div className="space-y-1">
            <Label className="text-[#3F3E39]">
              Erişim anahtarı (access token) <Ortamdan k={k.access_token} />
              {g.access_token_var && k.access_token !== 'ortam' && (
                <span className="ml-1 text-xs text-[#3d6e4e]">
                  (kayıtlı{g.access_token_son4 ? ` · …${g.access_token_son4}` : ''})
                  <button type="button" className="ml-1 underline text-[#9b3b2f]"
                    onClick={() => sil('access_token', 'Erişim anahtarı')}>sil</button>
                </span>
              )}
            </Label>
            <Input type="password" value={f.access_token} autoComplete="new-password"
              disabled={k.access_token === 'ortam'} data-testid="wa-token"
              placeholder={g.access_token_var ? '•••••• (değiştirmek için yapıştırın)' : 'EAA…'}
              onChange={(e) => setF(p => ({ ...p, access_token: e.target.value }))}
              className="bg-white border-[#d0c4b0]" />
          </div>
          <div className="space-y-1">
            <Label className="text-[#3F3E39]">
              App Secret <Ortamdan k={k.app_secret} />
              {g.app_secret_var && k.app_secret !== 'ortam' && (
                <span className="ml-1 text-xs text-[#3d6e4e]">(kayıtlı
                  <button type="button" className="ml-1 underline text-[#9b3b2f]"
                    onClick={() => sil('app_secret', 'App Secret')}>sil</button>)
                </span>
              )}
            </Label>
            <Input type="password" value={f.app_secret} autoComplete="new-password"
              disabled={k.app_secret === 'ortam'} data-testid="wa-app-secret"
              placeholder={g.app_secret_var ? '•••••• (değiştirmek için yapıştırın)' : ''}
              onChange={(e) => setF(p => ({ ...p, app_secret: e.target.value }))}
              className="bg-white border-[#d0c4b0]" />
          </div>
        </div>

        <div className="grid gap-3 xl:grid-cols-2">
          <div className="space-y-1">
            <Label className="text-[#3F3E39]">Butonlu şablon adı</Label>
            <Input value={f.sablon_linkli} placeholder="toros_bildirim" data-testid="wa-sablon-linkli"
              onChange={(e) => setF(p => ({ ...p, sablon_linkli: e.target.value.trim() }))}
              className="bg-white border-[#d0c4b0] font-mono text-xs" />
          </div>
          <div className="space-y-1">
            <Label className="text-[#3F3E39]">Butonsuz şablon adı</Label>
            <Input value={f.sablon_bilgi} placeholder="toros_bilgilendirme" data-testid="wa-sablon-bilgi"
              onChange={(e) => setF(p => ({ ...p, sablon_bilgi: e.target.value.trim() }))}
              className="bg-white border-[#d0c4b0] font-mono text-xs" />
          </div>
          <p className="xl:col-span-2 text-[11px] text-[#8a7e70] -mt-2">
            Meta'da ONAYLANAN şablon adıyla birebir aynı olmalı (dil: tr). Gövde: {'{{1}}'} alıcı, {'{{2}}'} konu,
            {' {{3}}'} açıklama; butonlu şablonda URL butonu https://erp.torosinvest.com.tr/{'{{1}}'}.
          </p>
        </div>

        <div className="space-y-1">
          <Label className="text-[#3F3E39]">Webhook doğrulama metni (Verify token) <Ortamdan k={k.webhook_verify_token} /></Label>
          <div className="flex gap-2">
            <Input readOnly value={g.webhook_verify_token || '— üretilmedi —'} data-testid="wa-verify-token"
              className="bg-white border-[#d0c4b0] font-mono text-xs" />
            {g.webhook_verify_token && (
              <Button type="button" variant="outline" className="border-[#d0c4b0]" title="Kopyala"
                onClick={() => kopyala(g.webhook_verify_token)}><Copy size={14} /></Button>
            )}
            {k.webhook_verify_token !== 'ortam' && (
              <Button type="button" variant="outline" className="border-[#d0c4b0] whitespace-nowrap"
                disabled={!g.sifreleme_hazir} onClick={metinUret} data-testid="wa-verify-uret">
                <RefreshCw size={14} className="mr-1" /> {g.webhook_verify_token ? 'Yenile' : 'Üret'}
              </Button>
            )}
          </div>
          <p className="text-[11px] text-[#8a7e70]">Meta panelinde webhook kurulurken "Verify token" alanına yapıştırılır.</p>
        </div>

        <div className="flex flex-wrap items-center gap-2 pt-1">
          <Button onClick={() => kaydet()} disabled={mesgul} data-testid="wa-kaydet"
            className="bg-[#2e2d29] text-[#f5f0e8] hover:bg-[#1a1916]">Kaydet</Button>
          <Button variant="outline" onClick={baglantiDene} disabled={test?.mesgul || !g.access_token_var}
            className="border-[#d0c4b0]" data-testid="wa-baglanti-testi">
            <ShieldCheck size={14} className="mr-1" /> Bağlantıyı test et
          </Button>
          <span className="text-[11px] text-[#8a7e70]">Test mesaj göndermez; yalnız anahtarı ve numarayı doğrular.</span>
        </div>
        {test && !test.mesgul && (
          <p className={`text-sm rounded-md px-3 py-2 border ${test.ok
            ? 'text-[#3d6e4e] bg-[#3d6e4e]/10 border-[#3d6e4e]/30'
            : 'text-[#9b3b2f] bg-[#9b3b2f]/10 border-[#9b3b2f]/30'}`} data-testid="wa-test-sonuc">
            {test.ok
              ? <>Bağlantı çalışıyor: <b>{test.ad}</b> · {test.numara}{test.kalite ? ` · kalite: ${test.kalite}` : ''}</>
              : test.hata}
          </p>
        )}

        {/* Şablonlar: Meta'daki durum + buradan onaya gönderme. Metin sunucuda
            sabit (whatsapp.SABLON_METNI) — önizleme ile Meta'daki şablon aynı. */}
        {g.access_token_var && <SablonBolumu />}

        {/* Gerçek test gönderimi: deneme modu açık olsa da gider, ama YALNIZ
            test listesindeki numaraya. Şablon onayını ve butonu telefonda görmek için. */}
        {g.access_token_var && g.test_whitelist?.length > 0 && (
          <div className="rounded-md border border-[#d0c4b0] bg-white px-3 py-2.5 space-y-2">
            <p className="text-sm font-semibold text-[#3F3E39]">Test mesajı</p>
            <div className="flex flex-wrap items-center gap-2">
              <select value={testNo} onChange={(e) => setTestNo(e.target.value)}
                className="h-9 rounded-md border border-[#d0c4b0] bg-white px-2 text-sm font-mono" data-testid="wa-test-no">
                {g.test_whitelist.map(n => <option key={n} value={n}>+{n}</option>)}
              </select>
              <Button size="sm" variant="outline" disabled={testGonder.mesgul} onClick={() => testMesaji(true)}
                className="border-[#d0c4b0] text-[#3d6e4e]" data-testid="wa-test-linkli">Butonlu şablonu gönder</Button>
              <Button size="sm" variant="outline" disabled={testGonder.mesgul} onClick={() => testMesaji(false)}
                className="border-[#d0c4b0] text-[#3d6e4e]" data-testid="wa-test-bilgi">Butonsuz şablonu gönder</Button>
            </div>
            <p className="text-[11px] text-[#8a7e70]">Deneme modu açık olsa da GERÇEKTEN gönderilir; yalnız test numaralarına.</p>
            {testGonder.sonuc && (
              <p className={`text-xs ${testGonder.sonuc.durum === 'gonderildi' ? 'text-[#3d6e4e]' : 'text-[#9b3b2f]'}`}
                data-testid="wa-test-mesaj-sonuc">
                {testGonder.sonuc.durum === 'gonderildi' ? 'Gönderildi — telefonunuzu kontrol edin.' : (testGonder.sonuc.hata || testGonder.sonuc.durum)}
              </p>
            )}
          </div>
        )}

        {g.degisiklikler?.length > 0 && (
          <details className="text-xs text-[#8a7e70]">
            <summary className="cursor-pointer">Değişiklik geçmişi</summary>
            <ul className="mt-1 space-y-0.5">
              {g.degisiklikler.map((d, i) => (
                <li key={i}>{new Date(d.zaman).toLocaleString('tr-TR')} — {d.kim}: {d.alanlar.join(', ')}</li>
              ))}
            </ul>
          </details>
        )}
      </CardContent>
    </Card>
  );
}
